import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChatConversation } from '../../../domain/models/chat-conversation.model';
import { ChatMessage } from '../../../domain/models/chat-message.model';

@Component({
  selector: 'talk-to-your-data-conversation-panel',
  templateUrl: './conversation-panel.component.html',
  styleUrls: ['./conversation-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationPanelComponent {
  @Input() activeConversation: ChatConversation | null = null;
  @Input() loading: boolean | null = false;
  @Input() error: string | null = null;

  get messages(): readonly ChatMessage[] {
    if (!this.activeConversation) {
      return [];
    }

    return this.activeConversation.messages || [];
  }
}
